import { render, staticRenderFns } from "./_ReportTabs.vue?vue&type=template&id=5ae1e0d2"
import script from "./_ReportTabs.vue?vue&type=script&lang=js"
export * from "./_ReportTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports